var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.342 22.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.046 13.686a2.276 2.276 0 0 0-1.609-.666H5.678l4.2 4.2 1.351-1.351Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.01 9.991v6.816a4.2 4.2 0 0 1-4.2 4.2H6.112a4.2 4.2 0 0 1-4.2-4.2V6.112a4.2 4.2 0 0 1 4.2-4.2h10.7a4.2 4.2 0 0 1 4.06 3.175c.521-.457 1.037-.918 1.555-1.377A6.116 6.116 0 0 0 16.808 0H6.112A6.112 6.112 0 0 0 0 6.112v10.7a6.112 6.112 0 0 0 6.112 6.108h10.7a6.112 6.112 0 0 0 6.112-6.112V7.243L21.6 8.561a2.018 2.018 0 0 0-.593 1.43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.879 17.22 26.347.761h-1.763a2.279 2.279 0 0 0-1.609.666L8.528 15.869Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.e980d8c8f43e162cb80f3b4f799b9890.svg";
export { ForwardRef as ReactComponent };